import React from "react";
import { InputAdornment, styled, TextField } from "@mui/material";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import CopyIcon from "@icons/myicons/copy.svg?react";

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    backgroundColor: "transparent",
    borderRadius: "8px",
    fontSize: theme.typography.body3.fontSize,
    cursor: "pointer",
  },
  "& .MuiInputBase-input": {
    padding: "7px 12px",
    cursor: "pointer",
    caretColor: "transparent",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.primary.main,
    borderRadius: "8px",
  },
}));

type CopyInputFieldProps = {
  value: string;
  color?: string;
};

export const CopyInputField = ({ value, color }: CopyInputFieldProps) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const handleCopy = () => {
    navigator.clipboard.writeText(value);
    enqueueSnackbar(t("copiedToClipboard"), {
      variant: "success",
      autoHideDuration: 2000,
    });
  };

  return (
    <StyledTextField
      value={value}
      fullWidth
      size="small"
      onClick={handleCopy}
      onKeyDown={(event) => {
        if (event.key === "Enter") {
          event.preventDefault();
          handleCopy();
        }
      }}
      slotProps={{
        input: {
          readOnly: true,
          sx: { color: color || "inherit" },
          endAdornment: (
            <InputAdornment
              position="end"
              sx={{ cursor: "pointer", color: color || "inherit" }}
            >
              <CopyIcon width={24} height={24} />
            </InputAdornment>
          ),
        },
      }}
    />
  );
};
